(function() {
	"use strict";

	angular.module( "ATMGurus" )

	.directive( "trainingSchedule", [
		"classesBookingService",
		"Auth",
		function( classesBookingService, Auth ) {
			return {
				restrict: "AE",
				priority: 16,
				template: require('Templates/bits/training-schedule.html'),
				controllerAs: "scheduleCtrl",
				link: function( scope, element, attrs ) {
					classesBookingService.getClasses()
						.then( function( classes ) {
							scope.classes = classes;
						})

					Auth.isLogged()
						.then(function(is_he) {
							scope.isLogged = true
						})
						.catch(response => {
							scope.isLogged = false
						})

				},
				controller: [ "$scope", "$element", "$attrs",  function( $scope, $element, $attrs ) {

					this.book = classesBookingService.book;

					this.isLogged = function() {
						return $scope.isLogged;
					}

					this.isBooked = function( classId ) {
						return classesBookingService.getBookedClasses()[ classId ];
					}

				} ],
			}
		}
	])
})()


// WEBPACK FOOTER //
// ./src/app/directives/trainingSchedule.js